import { ErrorBaseData } from '.'

export const physicianErrors: Record<string, ErrorBaseData> = {
  PhysicianNotFoundException: {
    message: 'Médico não encontrado',
    description: 'Não foi possível encontrar o médico. Verifique as informações e tente novamente',
  },
  PhysicianHasNoPhone: {
    message: 'Médico sem telefone cadastrado',
    description: 'Não foi possível enviar o código pelo telefone',
  },
  PhysicianAlreadyExistsException: {
    message: 'Médico já cadastrado',
    description: 'Este médico já foi cadastrado. Verifique as informações e tente novamente',
  },
  AlreadyExistingUserException: {
    message: 'Email já cadastrado!',
    description: 'Tente outro email.',
  },
}
